// extracted by mini-css-extract-plugin
module.exports = {"Terms":"_3qkV6VKG","termsContent":"LwsbrHmq","termsContentIndented":"_174t-BvW","termsContentDoubleIndented":"_255CorBA","termsContentTripleIndented":"_1lFhJs3J","termsBold":"_37wMabcE","termsUnderline":"_2eT5GWWZ","termsBoldUnderline":"RgS2GoXm","termsBoldCentered":"_3YCYUqwM","termsText":"_3Bev94xS"};
    if(module.hot) {
      // 1754514920951
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  